import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ChevronDownIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M4 6L7.82322 9.82322C7.92085 9.92085 8.07915 9.92085 8.17678 9.82322L12 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
